<template lang="pug">
div
  el-card(shadow="hover").espacamento
    div.cardHeader
      b Dados do Cálculo:
      el-button(
        type="primary"
        v-if="isVisualizar && showAnteciparParcelas"
        @click="antecipacaoParcela"
      ) Solicitar Antecipação/Quitação de custas de VTN
    div#line
    p(style="color: red; font-size: 13px" v-if="exibeObs") Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI).
    div.center
      el-col(:span='8').flex
        app-display(label="Munícipio:", :content="dadosVtn.pvtn.municipio.nomeComCodigoEstadoFormatado" :contentAlignRight="true")
        app-display(label="Módulo fiscal do Município (MF):", :content="dadosVtn.pvtn.municipio.mf", :contentAlignRight="true")
        app-display(label="Área Requerida (A):", :content="dadosVtn.areaRequeridaFormatada", :contentAlignRight="true")
        app-display(label="Número de módulos fiscais:", :content="dadosVtn.nmoduloFiscalFormatado", toolTip="left-end", :textIcon="numeroModulosFiscais()", :contentAlignRight="true")
        app-display(label="Percentual a ser aplicado sobre o VTN:", :content="dadosVtn.percentualAplicadoFormatado", toolTip="left-end", :textIcon="percentualAplicadoVtn()", :contentAlignRight="true")
        app-display(label="Coeficiente Angular:", :content="dadosVtn.coeficienteAngularFormatado", toolTip="left-end", :textIcon="coeficienteAngular()", :contentAlignRight="true")
        app-display(label="Coeficiente Linear:", :content="dadosVtn.coeficienteLinearFormatado", toolTip="left-end", :textIcon="coeficienteLinear()", :contentAlignRight="true")
      el-col(:span='8').flex
        app-display(label="Valor mínimo da Pauta de VTN (PVTN):", :content='`${dadosVtn.pvtn.vtnPorHaMinFormatado}`', :contentAlignRight="true")
        app-display(label="Percentual do bônus utilizado no cálculo:", :content="intervaloPercentual", :contentAlignRight="true")
        app-display(label="Prazo mínimo de inalienabilidade do imóvel:", :content='getPrazoMinimo', :contentAlignRight="true")
        app-display(label="Pagamento:", content='até 20 (vinte) parcelas anuais e sucessivas', :contentAlignRight="true")
        app-display(label="Juros:", :content="jurosText", toolTip="left-end", :textIcon="juros()", :contentAlignRight="true")
        app-display(label="Carência:", :content="carenciaText", :contentAlignRight="true")
        app-display(label="Valor Final do Imóvel (VFI):", :content="formataMoeda(dadosVtn.valorFinalImovel)", :contentAlignRight="true")
  observacoes.espacamento(v-if="exibeCardObs")
</template>

<script>
import Observacoes from './Observacoes.vue'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  components: {
    AppDisplay,
    AppDivider,
    Observacoes
  },

  props: {
    dadosVtn: {
      type: Object,
      required: true
    },
    exibeObs: {
      type: Boolean,
      required: false,
      default: false
    },
    isVisualizar: {
      type: Boolean,
      required: false,
      default: false
    },
    processo: {
      type: Object,
      required: false
    },
    exibeCardObs: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  computed: {
    intervaloPercentual () {
      if (this.dadosVtn.percentualAplicado >= 0.01 && this.dadosVtn.percentualAplicado < 0.3) {
        return 'entre 10% e 30%'
      } else {
        return 'entre 30% e 50%'
      }
    },

    showAnteciparParcelas () {
      return !this.dadosVtn.status.includes('Aguardando validação', 'Criado')
    },

    jurosText () {
      if (this.dadosVtn.percentualAplicado >= 0.01 && this.dadosVtn.percentualAplicado < 0.3) {
        return '3% ao ano + correção monetária'
      } else {
        return '5% ao ano + correção monetária'
      }
    },

    carenciaText () {
      if (this.dadosVtn.percentualAplicado >= 0.01 && this.dadosVtn.percentualAplicado < 0.3) {
        return '3% ao ano após a expedição do Título de Domínio'
      } else {
        return '5% ao ano após a expedição do Título de Domínio'
      }
    },
    getPrazoMinimo () {
      return this.processo?.tipo?.codigo === 'NAO_ONEROSO' ? '10 (dez) anos' : '03 (três) anos'
    }
  },

  methods: {
    numeroModulosFiscais () {
      return 'Número de Módulos fiscais = Área Requerida / Módulo fiscal do município'
    },

    percentualAplicadoVtn () {
      return '(Coeficiente Angular x  Área requerida) +  Coeficiente Linear =  Percentual a ser aplicado sobre o VTN'
    },

    coeficienteLinear () {
      return `Processos com áreas acima de 01 Módulo Fiscal até 04 Módulos Fiscais: <br/>
            - Em municípios de 50 Módulos Fiscais: Coeficiente Linear é 3,333315556. <br/>
            - Em municípios de 70 Módulos Fiscais: Coeficiente Linear é 3,333320635. <br/> <br/>
              Processos com áreas acima de 04 Módulos Fiscais e até 2.500 hectares: <br/>
            - Em municípios de 50 Módulos Fiscais: Coeficiente Linear é 28,26086862. <br/>
            - Em municípios de 70 Módulos Fiscais: Coeficiente Linear é 27,47747646.`
    },

    coeficienteAngular () {
      return `Processos com áreas acima de 01 Módulo Fiscal até 04 Módulos Fiscais: <br/>
              - Em municípios de 50 Módulos Fiscais: Coeficiente Angular é 0,133333422. <br/>
              - Em municípios de 70 Módulos Fiscais: Coeficiente Angular é 0,095238141. <br/> <br/>
              Processos com áreas acima de 04 Módulos Fiscais e até 2.500 hectares: <br/>
              - Em municípios de 50 Módulos Fiscais: Coeficiente Angular é 0,008695653. <br/>
              - Em municípios de 70 Módulos Fiscais: Coeficiente Angular é 0,009009009.`
    },

    juros () {
      return 'O valor da correção monetária será atualizado anualmente.'
    },

    antecipacaoParcela () {
      this.$router.push({
        name: 'vtn/antecipacao-parcela',
        params: {
          processo: this.processo
        }
      })
    },

    formataMoeda (valor) {
      let formatado = valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      return formatado
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 13%;
}
.flex {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: inherit;
}

.espacamento {
  margin-top: 3%;
  margin: 20px;
  border-radius: 10px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#line {
  width: 100%;
  background-color: gainsboro;
  height: 2px;
  margin-top: 11px;
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/ConfirmarDados.vue